export const GET_TRANSACTION_LIST = 'TRANSACTION/get_transaction_list';

export const CHECKOUT_DRAFT_TRANSACTION = 'TRANSACTION/checkout_draft_transaction';
export const CHECKOUT_DRAFT_TRANSACTION_SUCCESS = 'TRANSACTION/checkout_draft_transaction_success';

export const CANCEL = 'TRANSACTION/CANCEL';
